import React, { useEffect } from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { numToLetter } from '~/commons/helpers';

const FieldsMultiSelect = ({
  qtnIndex: i,
  restrictEdit = false,
  fileUploadUrl,
}) => {
  const [, { value }] = useField(`questions.${i}`);
  const [, , { setValue: setAns }] = useField(`questions.${i}.answers`);
  const { t } = useTranslation();
  const { answers } = value;
  let { choices } = value;

  // Ensure choices is an array and handle mixed formats
  if (!Array.isArray(choices)) {
    choices = [];
  }

  // Filter out empty choices for restrictEdit mode
  if (!restrictEdit && choices.length > 0) {
    const lastChoice = choices[choices.length - 1];
    if ((typeof lastChoice === 'string' && !lastChoice.trim())
        || (typeof lastChoice === 'object' && (!lastChoice.text || !lastChoice.text.trim()))) {
      choices = choices.slice(0, -1);
    }
  }

  useEffect(() => {
    if (answers.find((a) => a >= choices.length)) {
      setAns(answers.filter((a) => a < choices.length));
    }
  }, [choices.length]);

  useEffect(() => {
    if (!value?.answers?.length) {
      setAns([]);
    }
  }, []);

  return (
    <>
      <label>{t('Choices')} *</label>
      <FieldArrayIterables
        name={`questions.${i}.choices`}
        {...restrictEdit ? {} : {
          tail: { text: '', img: '' }, // Default structure for new choices
        }}
      >
        {(c, ii) => {
          // Handle both string and object formats
          const isObject = typeof c === 'object' && c !== null;
          const choiceText = isObject ? c.text || '' : c || '';

          return (
            <div className="form-row align-items-start mb-3" key={ii}>
              <div className="col-auto pt-2">
                {numToLetter(ii, true)}.
              </div>
              <div className="col">
                {/* Choice Text Input */}
                <FormGroup
                  checkbox={{
                    name: `questions.${i}.answers`,
                    value: ii.toString(),
                    disabled: ii >= choices.length || (!choiceText.trim()),
                  }}
                  name={isObject ? `questions.${i}.choices.${ii}.text` : `questions.${i}.choices.${ii}`}
                  label="Choice Text"
                  placeholder="Enter choice text..."
                />

                {/* Image Upload */}
                <FormGroup
                  className="contain"
                  name={`questions.${i}.choices.${ii}.img`}
                  as="coverImg"
                  label="Choice Image (optional)"
                  api={fileUploadUrl}
                />

                {/* No need for image preview as coverImg component handles it */}
              </div>
            </div>
          );
        }}
      </FieldArrayIterables>
    </>
  );
};

export default FieldsMultiSelect;
